exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.detailsHost .hostImg[data-v-73a449b7] {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.2rem;\n  overflow: hidden;\n}\n.detailsHost .hostImg img[data-v-73a449b7] {\n  height: 100%;\n}\n.detailsHost .shap[data-v-73a449b7] {\n  width: 0.5rem;\n  height: 0.65rem;\n}\n.detailsHost .shap img[data-v-73a449b7] {\n  width: 100%;\n  margin-top: -0.2rem;\n}\n.detailsHost .textright[data-v-73a449b7] {\n  display: inline-block;\n  height: 1rem;\n}\n.detailsHost .textright img[data-v-73a449b7] {\n  width: auto;\n  height: 100%;\n}", ""]);

// exports
